export enum ReportStatus {
	IN_PROGRESS = 'IN_PROGRESS',
	FINISHED = 'FINISHED',
	ERROR = 'ERROR',
	OUTDATED = 'OUTDATED',
	EMPTY = 'EMPTY',
}

export enum TaxAnalysisStatus {
	IN_PROGRESS = 'IN_PROGRESS',
	FINISHED = 'FINISHED',
	ERROR = 'ERROR',
	OUTDATED = 'OUTDATED',
	EMPTY = 'EMPTY',
}

export enum RecalculationStatus {
	IN_PROGRESS = 'IN_PROGRESS',
	FINISHED = 'FINISHED',
	ERROR = 'ERROR',
}

export interface IReportDto {
	filename?: string
	reportName: string
	status?: ReportStatus | null
	url?: string
	progress: number
}

export interface IAnalyzeStatusDto {
	progress: number
	status: TaxAnalysisStatus | null
}

export interface IRecalculationStatusDto {
	progress: number
	status: RecalculationStatus | null
}
